<template>
  <v-menu
    ref="menu"
    v-model="showPicker"
    :close-on-content-click="false"
    :nudge-top="250"
    transition="scale-transition"
    offset-y
    offset-x
    absolute
    :disabled="disabled"
  >
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <v-text-field
          :id="id"
          v-model="dateTime"
          :messages="messages"
          :label="label"
          :error="errorMessages"
          :error-message="errorMessages"
          :hint="hint"
          :persistent-hint="persistentHint"
          :hide-details="!hint"
          :disabled="disabled"
          clearable
          flat
          readonly
          :clear-icon="$getIcon('mdiClose')"
          :prepend-inner-icon="$getIcon('mdiCalendarMonthOutline')"
          @paste.prevent
          @click:append="resetDateTime"
          @blur="$emit('update')"
        ></v-text-field>
        <span v-if="errorMessages" class="red--text caption">
          <span v-if="Array.isArray(errorMessages)">{{
            errorMessages[0]
          }}</span>
          <span v-else>{{ errorMessages }}</span>
        </span>
      </div>
    </template>
    <v-card tile>
      <v-row no-gutters class="shade">
        <v-col>
          <v-btn
            v-if="showDatePicker && international"
            block
            depressed
            tile
            color="shade primary--text font-weight-bold"
            @click="international = !international"
          >
            NE
          </v-btn>
        </v-col>
        <v-col>
          <v-btn
            block
            depressed
            tile
            color="shade"
            @click="showDatePicker = !showDatePicker"
          >
            <v-icon
              v-if="showDatePicker"
              color="primary"
              v-text="$getIcon('mdiClockOutline')"
            ></v-icon>
            <v-icon
              v-else
              color="primary"
              v-text="$getIcon('mdiCalendarMonthOutline')"
            ></v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-btn
            v-if="showDatePicker && !international"
            block
            depressed
            tile
            color="shade primary--text font-weight-bold"
            @click="international = !international"
          >
            EN
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-card v-if="showDatePicker" tile>
      <localized-calendar
        v-if="!international"
        ref="datePicker"
        v-model="date"
        :fiscal-year="[]"
        @input="setDate"
        @limit-mapping="limitMapping = $event"
      >
      </localized-calendar>
      <v-date-picker
        v-else
        ref="datePicker"
        v-model="date"
        :allowed-dates="allowedDates"
        color="primary"
        no-title
        @change="setDate"
      ></v-date-picker>
    </v-card>
    <v-card v-else tile class="white">
      <v-responsive width="200">
        <div id="time-picker" class="d-flex">
          <v-text-field
            v-model="hour"
            mask="##"
            class="mx-4"
            type="number"
          ></v-text-field>
          <span class="my-auto" v-text="':'"></span>
          <v-text-field
            v-model="minute"
            mask="##"
            class="mx-4"
            type="number"
          ></v-text-field>
        </div>
        <v-divider></v-divider>
        <v-row align="center">
          <v-col class="text-center">
            <div>
              <v-btn icon color="primary" @click="changeHour('increment')">
                <v-icon v-text="$getIcon('mdiChevronUp')"> </v-icon>
              </v-btn>
            </div>
            <v-btn icon color="primary">
              {{ hour }}
            </v-btn>
            <div>
              <v-btn icon color="primary" @click="changeHour('decrement')">
                <v-icon v-text="$getIcon('mdiChevronDown')"> </v-icon>
              </v-btn>
            </div>
          </v-col>
          <span v-text="':'"></span>
          <v-col class="text-center">
            <div>
              <v-btn icon color="primary" @click="changeMinute('increment')">
                <v-icon v-text="$getIcon('mdiChevronUp')"> </v-icon>
              </v-btn>
            </div>
            <v-btn icon color="primary">
              {{ minute }}
            </v-btn>
            <div>
              <v-btn color="primary" icon @click="changeMinute('decrement')">
                <v-icon v-text="$getIcon('mdiChevronDown')"> </v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <!--        <v-divider></v-divider>-->
        <!--        <v-btn-->
        <!--          block-->
        <!--          color="primaryLight"-->
        <!--          @click="showDatePicker = true"-->
        <!--        >-->
        <!--          <v-icon-->
        <!--            color="primary"-->
        <!--            v-text="'mdi-calendar-month-outline'"-->
        <!--          ></v-icon>-->
        <!--        </v-btn>-->
      </v-responsive>
    </v-card>
  </v-menu>
</template>
<script>
import LocalizedCalendar from "@/components/common/form_utils/LocalizedCalendar";
export default {
  components: { LocalizedCalendar },
  props: {
    placeHolder: {
      type: String,
      required: false,
      default() {
        return "YYYY-MM-DD HH:MM:SS";
      }
    },
    messages: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: undefined
    },
    id: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    hint: {
      type: String,
      default: undefined
    },
    persistentHint: {
      type: Boolean,
      default: false
    },
    initialTimeView: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: [String, Array],
      default() {
        return [];
      }
    }
  },
  data: () => ({
    showPicker: false,
    menu: false,
    date: "",
    dateTime: "",
    showDatePicker: true,
    hour: "",
    minute: "",
    international: false
  }),
  computed: {
    time() {
      if (!this.hour || !this.minute) return "";
      return this.hour + ":" + this.minute;
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.dateTime = val.split("T").join(" ");
        this.date = val.split("T")[0];
        const time = val.split("T")[1];
        if (time) {
          this.hour = time.split(":")[0];
          this.minute = time.split(":")[1];
        }
      } else {
        this.dateTime = val;
      }
    },
    hour(val) {
      val = parseInt(val);
      if (val > 23) this.hour = 23;
      if (val < 0) this.hour = 23;
      this.setDate();
      if (
        val.toString() !== "00" &&
        val.toString() !== "0" &&
        isNaN(val) === false
      ) {
        setTimeout(() => {
          this.hour =
            (this.hour < 10 && this.hour.toString().length < 2 ? "0" : "") +
            this.hour.toString();
        }, 1000);
      }
    },
    minute(val) {
      val = parseInt(val);
      if (val > 59) this.minute = 59;
      if (val < 0) this.minute = 0;
      this.setDate();
      if (
        val.toString() !== "00" &&
        val.toString() !== "0" &&
        isNaN(val) === false
      ) {
        setTimeout(() => {
          this.minute =
            (this.minute < 10 && this.minute.toString().length < 2 ? "0" : "") +
            this.minute.toString();
        }, 1000);
      }
    },
    dateTime(val) {
      if (val) {
        this.$emit("input", val.split(" ").join("T"));
        this.$emit("blur");
      } else {
        this.$emit("input", "");
      }
    },
    showPicker(val) {
      if (val && !this.dateTime) {
        this.date = this.$dayjs().format("YYYY-MM-DD");
        this.hour = this.$dayjs().format("HH");
        this.minute = this.$dayjs().format("mm");
        this.setDate();
      }
    }
  },
  created() {
    if (this.value) {
      this.date = this.$dayjs(this.value).format("YYYY-MM-DD");
      this.hour = this.$dayjs(this.value).format("HH");
      this.minute = this.$dayjs(this.value).format("mm");
    }
    this.$nextTick(() => {
      this.showDatePicker = !this.initialTimeView;
    });
  },
  methods: {
    changeHour(action) {
      this.hour = parseInt(this.hour);
      if (action === "increment") {
        if (this.hour === 23) this.hour = 0;
        else this.hour += 1;
      } else {
        if (this.hour === 0) this.hour = 23;
        else this.hour -= 1;
      }
    },
    changeMinute(action) {
      this.minute = parseInt(this.minute);
      if (action === "increment") {
        if (this.minute === 59) {
          this.minute = 0;
          this.changeHour("increment");
        } else this.minute += 1;
      } else {
        if (this.minute === 0) {
          this.minute = 59;
          this.changeHour("decrement");
        } else this.minute -= 1;
      }
    },
    setDate() {
      this.dateTime =
        !this.date && !this.time ? "" : this.date + " " + this.time;
    },
    resetDateTime() {
      this.showPicker = false;
      this.dateTime = "";
      this.$emit("input", "");
      this.$emit("blur");
    },
    allowedDates(val) {
      return val <= this.limitMapping.max && val >= this.limitMapping.min;
    }
  }
};
</script>
<style>
#time-picker input {
  text-align: center !important;
}
</style>
